import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CtaButtonContext } from '@/components/astro/cta-button/cta-button';

export const Route = createFileRoute('/_marketing/blog')({
  component: () => (
    <CtaButtonContext
      value={{
        href: '/',
        analyticsCheckout: false,
      }}
    >
      <Outlet />
    </CtaButtonContext>
  ),
});
